// Stripe Cloud Functions API
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export async function createStripeCheckoutSession(priceId: string, mode: 'payment' | 'subscription'): Promise<string> {
    const createCheckoutSession = httpsCallable(functions, 'createCheckoutSession');
    const { data } = await createCheckoutSession({ priceId, mode });
    return (data as any).sessionId;
}

export async function createStripeCartCheckoutSession(priceIds: string[]): Promise<string> {
    const createCheckoutSession = httpsCallable(functions, 'createCheckoutSession');
    const { data } = await createCheckoutSession({ priceIds, mode: 'payment' });
    return (data as any).sessionId;
}

export async function createStripePortalSession(): Promise<string> {
    const createPortalSession = httpsCallable(functions, 'createPortalSession');
    const { data } = await createPortalSession({});
    return (data as any).url;
}

// A single line item within a purchase (one sound pack).
export type PackPurchaseItem = {
    description: string | null; // pack name as it appeared at checkout
    quantity: number | null;
    amount: number | null; // in the currency's minor unit (e.g. cents)
};

// One completed pack purchase (a paid, one-time Checkout Session).
export type PackPurchase = {
    id: string;
    created: number; // UNIX seconds
    amountTotal: number | null; // minor unit
    currency: string | null;
    items: PackPurchaseItem[];
};

/**
 * Fetches the user's one-time sound pack purchase history from Stripe (via the
 * listPackPurchases Cloud Function). Returns purchases newest-first.
 */
export async function listPackPurchases(): Promise<PackPurchase[]> {
    const listPurchases = httpsCallable(functions, 'listPackPurchases');
    const { data } = await listPurchases({});
    const purchases = ((data as any).purchases ?? []) as PackPurchase[];
    return purchases.sort((a, b) => b.created - a.created);
}
